export default __webpack_public_path__ + "static/compareItemImg5-ba004a90a4b2ee50c65c15d6a170f6e9.png";